<template>
  <div class="ConfigImg">
    <img
      v-if="!show&&$options.propsData.type!='Pic'&&$options.propsData.type!='XT'&&$options.propsData.type!='SN'&&$options.propsData.type!='RM'&&$options.propsData.type!='HI'&&$options.propsData.type!='HC'&&$options.propsData.type!='HCI'"
      :src="$options.propsData.imgLink||$options.propsData.mainImg"
    />
    <img v-if="!show&&$options.propsData.type==='Pic'" :src="$options.propsData.data.pic" />
    <img v-if="!show&&$options.propsData.type==='QRCode'" :src="$options.propsData.data.qrcode" />
    <img v-if="!show&&$options.propsData.type==='XT'" :src="$options.propsData.data.content" />
    <img v-if="!show&&$options.propsData.type==='SN'" :src="$options.propsData.data.pic" />
    <img v-if="!show&&$options.propsData.type==='RM'" :src="$options.propsData.data.logo" />
    <img v-if="!show&&$options.propsData.type==='HI'" :src="$options.propsData.data.homeLogo" />
    <img v-if="!show&&$options.propsData.type==='HC'" :src="$options.propsData.data.popImg" />
    <img v-if="!show&&$options.propsData.type==='HCI'" :src="$options.propsData.data.pic" />
    <img id="preview" />

    <input type="file" name="file" id="input_file" @change="upload" />
    <button
      v-if="$options.propsData.type==='HI'||$options.propsData.type==='HCI'"
      @click="DelFeil"
    >删除图片</button>
  </div>
</template>

<script>
import Vue from "vue";
/*引入资源请求插件*/
import VueResource from "vue-resource";

import { api } from "../biz/api";

export default {
  name: "ConfigImg",
  components: {},

  data() {
    return {
      show: false
    };
  },
  mounted: function() {},
  methods: {
    DelFeil() {
      if (this.$options.propsData.type === "HI") {
        api.DelFeil(this.$options.propsData.data.homeLogo).then(res => {
          let data = this.$options.propsData.data;
          data.homeLogo = "";
          let c = JSON.stringify(data.content);
          c = JSON.parse(c);
          c.brainPowerMoney = c.brainPowerMoney * 100;
          c.brainPowerQuota = c.brainPowerQuota * 100;
          c.emptyCardMoney = c.emptyCardMoney * 100;
          c.emptyCardQuota = c.emptyCardQuota * 100;
          c.speedyMoney = c.speedyMoney * 100;
          c.speedyQuota = c.speedyQuota * 100;
          data.content = c;

          api.Activityupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (this.$options.propsData.type === "HCI") {
        api.DelFeil(this.$options.propsData.data.pic).then(res => {
          let data = this.$options.propsData.data;
          let c = JSON.stringify(data.content);
          c = JSON.parse(c);
          c.brainPowerMoney = c.brainPowerMoney * 100;
          c.brainPowerQuota = c.brainPowerQuota * 100;
          c.emptyCardMoney = c.emptyCardMoney * 100;
          c.emptyCardQuota = c.emptyCardQuota * 100;
          c.speedyMoney = c.speedyMoney * 100;
          c.speedyQuota = c.speedyQuota * 100;
          data.content = c;
          data.pic = "";
          api.Activityupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
    },
    upload(e) {
      //判断是否支持FileReader
      if (window.FileReader) {
        var reader = new FileReader();
      } else {
        alert("您的设备不支持图片预览功能，如需该功能请升级您的设备！");
      }
      //获取文件
      var img = document.getElementById("input_file");
      var file = img.files[0];
      var imageType = /^image\//;
      //是否是图片
      if (!imageType.test(file.type)) {
        alert("请选择图片！");
        return;
      }
      //读取完成
      reader.onload = e => {
        this.show = true;
        //获取图片dom
        var img = document.getElementById("preview");
        //图片路径设置为读取的图片
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
      this.formData = e.target.files;   //创建一个forData

      var formData = new FormData();

      formData.append("file", $("#input_file")[0].files[0]);
      if (this.$options.propsData.imgLink) {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData;
          data.imgLink = res.body.data[0].path;
          api.GuideEdit(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (this.$options.propsData.mainImg) {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData;
          data.mainImg = res.body.data[0].path;
          api.SyshomeEdit(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (this.$options.propsData.type === "XT") {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData.data;
          data.content = res.body.data[0].path;
          api.Systempupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (this.$options.propsData.type === "SN") {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData.data;
          data.pic = res.body.data[0].path;
          api.Systemnupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (this.$options.propsData.type === "RM") {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData.data;
          data.logo = res.body.data[0].path;
          api.Sourceupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (this.$options.propsData.type === "HI") {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData.data;
          data.homeLogo = res.body.data[0].path;
          let c = JSON.stringify(data.content);
          c = JSON.parse(c);
          c.brainPowerMoney = c.brainPowerMoney * 100;
          c.brainPowerQuota = c.brainPowerQuota * 100;
          c.emptyCardMoney = c.emptyCardMoney * 100;
          c.emptyCardQuota = c.emptyCardQuota * 100;
          c.speedyMoney = c.speedyMoney * 100;
          c.speedyQuota = c.speedyQuota * 100;
          data.content = c;
          api.Activityupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (this.$options.propsData.type === "HC") {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData.data;
          data.popImg = res.body.data[0].path;
          let c = JSON.stringify(data.content);
          c = JSON.parse(c);
          c.brainPowerMoney = c.brainPowerMoney * 100;
          c.brainPowerQuota = c.brainPowerQuota * 100;
          c.emptyCardMoney = c.emptyCardMoney * 100;
          c.emptyCardQuota = c.emptyCardQuota * 100;
          c.speedyMoney = c.speedyMoney * 100;
          c.speedyQuota = c.speedyQuota * 100;
          data.content = c;
          api.Activityupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (this.$options.propsData.type === "HCI") {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData.data;
          data.pic = res.body.data[0].path;
          let c = JSON.stringify(data.content);
          c = JSON.parse(c);
          c.brainPowerMoney = c.brainPowerMoney * 100;
          c.brainPowerQuota = c.brainPowerQuota * 100;
          c.emptyCardMoney = c.emptyCardMoney * 100;
          c.emptyCardQuota = c.emptyCardQuota * 100;
          c.speedyMoney = c.speedyMoney * 100;
          c.speedyQuota = c.speedyQuota * 100;
          data.content = c;
          api.Activityupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
      if (
        this.$options.propsData.type === "Pic" ||
        this.$options.propsData.type === "QRCode"
      ) {
        api.ProductUploads(formData).then(res => {
          let data = this.$options.propsData.data;
          if (this.$options.propsData.type === "Pic") {
            data.pic = res.body.data[0].path;
          } else {
            data.qrcode = res.body.data[0].path;
          }
          api.Wechatupdate(data).then(res => {
            this.$layer.alert(res.body.message);
          });
        });
      }
    }
  }
};
</script>
<style scoped >
.ConfigImg {
  background: #fff;
  padding: 15px;
  height: 100%;
  width: 100%;
}
.ConfigImg img {
  width: 100%;
}
</style>